module.exports = __webpack_public_path__ + "img/noprize_img.3437c5bc.png";